import * as echarts from "echarts";
import { default as EChartsReact, default as ReactEcharts } from "echarts-for-react";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { DataRow, SplitBy, Tab, WidgetParameter } from "../../../../../stores/TabsStore";
import { ExcludeFilters, getExcludeDataText, getExcludeFilters } from "../../../../../components/Widgets/ExcludeData/ExcludeData";
import { hslColor } from "../../../../../enums/colors";


const Comparative = ({data, tab}:{data: DataRow[], tab: Tab}) => {

  return (
    <div className="py-6">
      <div className="">
        <div className="text-base font-semibold">По продолжительности взаимодействия</div>
        <div className="text-xs">Расчитывается как: вся продолжительность взаимодействия к продолжительности периода</div>
        <ComparativeByPersonsInteraction data={data} tab={tab}/>
      </div>
      <div className="">
        <div className="text-base font-semibold">По загрузке во взаимодействия</div>
        <div className="text-xs">Расчитывается как: вся полезная загрузка на продолжительность взаимодействия</div>
        <ComparativeByPersonsWorked data={data} tab={tab}/>
      </div>
    </div>
  )
}

export default Comparative;

const ComparativeByPersonsInteraction = ({data, tab}:{data: DataRow[], tab: Tab}) => {
  const [ref, setRef] = useState<EChartsReact | null>();
  const [loading, setLoading] = useState(true)
  const [filteredData, setFilteredData] = useState<DataRow[]>()
  const [excludeFilters, setExcludeFilters] = useState<ExcludeFilters>()
  const [calculations, setCalculations] = useState<any[]>()

  useEffect(() => {
    setLoading(true)
    setExcludeFilters(getExcludeFilters(data, data))
    setFilteredData(data)
  }, [])

  useEffect(() => {
    if(filteredData && filteredData.length > 0) {
      let c = blockCalculations(filteredData!, "availability.on", "duration.total", "persons", tab)
      setCalculations(c)
      setLoading(false)
    }
  }, [filteredData])

  const getOptions = () => (
    {
      animation: false,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: {
            show: true,
            formatter: function (params: { value: string; }) {
              return params.value.replace('\n', '');
            }
          }
        }
      },
      legend: {
        icon: "circle",
        bottom: 0,
        formatter: function (name: string) {
          return t(name);
        }
      },
      grid: {
        left: "12px",
        right: "8px",
        bottom: "30px",
        top: "8px",
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: excludeFilters?.filteredDays,
        axisLabel: {
          formatter: function (value: string) {
            return DateTime.fromSQL(value).toFormat("dd");
          },
        }
      },
      yAxis: {
        type: 'value',
        offset: 0,
        position: "right",
        axisLabel: {
          formatter: function (value: string) {
            return `${value} %`;
          },
        },
        splitLine: {
          show: false
        }
      },
      series: calculations
    }
  );

  return (
    <div className="flex flex-col w-full">
      <div className="flex w-full py-2 h-72">
        {!loading && <ReactEcharts
          option={getOptions()}
          showLoading={loading}
          loadingOption={{
            text: '',
            color: hslColor.primary,
            // textColor: store.theme === "dark" ? hslColor.lightBorder : hslColor.darkBorder,
            // maskColor: store.theme === "dark" ? hexColor.borderForeground : hexColor.border,
            zlevel: 0,
            // Font size. Available since `v4.8.0`.
            fontSize: 12,
            // Show an animated "spinner" or not. Available since `v4.8.0`.
            showSpinner: true,
            // Radius of the "spinner". Available since `v4.8.0`.
            spinnerRadius: 8,
            // Line width of the "spinner". Available since `v4.8.0`.
            lineWidth: 2,
            // Font thick weight. Available since `v5.0.1`.
            fontWeight: 'normal',
            // Font style. Available since `v5.0.1`.
            fontStyle: 'normal',
            // Font family. Available since `v5.0.1`.
            fontFamily: 'sans-serif'
          }}
          ref={(e) => {
            setRef(e);
          }}
          style={{ width: "100%", height: "100%", minHeight: 100 }}
          opts={{ renderer: "canvas" }}
        />}
      </div>
    </div>
  )
}

const ComparativeByPersonsWorked = ({data, tab}:{data: DataRow[], tab: Tab}) => {
  const [ref, setRef] = useState<EChartsReact | null>();
  const [loading, setLoading] = useState(true)
  const [filteredData, setFilteredData] = useState<DataRow[]>()
  const [excludeFilters, setExcludeFilters] = useState<ExcludeFilters>()
  const [calculations, setCalculations] = useState<any[]>()

  useEffect(() => {
    setLoading(true)
    setExcludeFilters(getExcludeFilters(data, data))
    setFilteredData(data)
  }, [])

  useEffect(() => {
    if(filteredData && filteredData.length > 0) {
      let c = blockCalculations(filteredData!, "availability.worked", "availability.on", "persons", tab)
      setCalculations(c)
      setLoading(false)
    }
  }, [filteredData])

  const getOptions = () => (
    {
      animation: false,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: {
            show: true,
            formatter: function (params: { value: string; }) {
              return params.value.replace('\n', '');
            }
          }
        }
      },
      legend: {
        icon: "circle",
        bottom: 0,
        formatter: function (name: string) {
          return t(name);
        }
      },
      grid: {
        left: "12px",
        right: "8px",
        bottom: "30px",
        top: "8px",
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: excludeFilters?.filteredDays,
        axisLabel: {
          formatter: function (value: string) {
            return DateTime.fromSQL(value).toFormat("dd");
          },
        }
      },
      yAxis: {
        type: 'value',
        offset: 0,
        position: "right",
        axisLabel: {
          formatter: function (value: string) {
            return `${value} %`;
          },
        },
        splitLine: {
          show: false
        }
      },
      series: calculations
    }
  );

  return (
    <div className="flex flex-col w-full">
      <div className="flex w-full py-2 h-72">
        {!loading && <ReactEcharts
          option={getOptions()}
          showLoading={loading}
          loadingOption={{
            text: '',
            color: hslColor.primary,
            // textColor: store.theme === "dark" ? hslColor.lightBorder : hslColor.darkBorder,
            // maskColor: store.theme === "dark" ? hexColor.borderForeground : hexColor.border,
            zlevel: 0,
            // Font size. Available since `v4.8.0`.
            fontSize: 12,
            // Show an animated "spinner" or not. Available since `v4.8.0`.
            showSpinner: true,
            // Radius of the "spinner". Available since `v4.8.0`.
            spinnerRadius: 8,
            // Line width of the "spinner". Available since `v4.8.0`.
            lineWidth: 2,
            // Font thick weight. Available since `v5.0.1`.
            fontWeight: 'normal',
            // Font style. Available since `v5.0.1`.
            fontStyle: 'normal',
            // Font family. Available since `v5.0.1`.
            fontFamily: 'sans-serif'
          }}
          ref={(e) => {
            setRef(e);
          }}
          style={{ width: "100%", height: "100%", minHeight: 100 }}
          opts={{ renderer: "canvas" }}
        />}
      </div>
    </div>
  )
}

const ComparativeByShifts = ({data, tab}:{data: DataRow[], tab: Tab}) => {
  const [ref, setRef] = useState<EChartsReact | null>();
  const [loading, setLoading] = useState(true)
  const [filteredData, setFilteredData] = useState<DataRow[]>()
  const [excludeFilters, setExcludeFilters] = useState<ExcludeFilters>()
  const [calculations, setCalculations] = useState<any[]>()

  useEffect(() => {
    setLoading(true)
    setExcludeFilters(getExcludeFilters(data, data))
    setFilteredData(data)
  }, [])

  useEffect(() => {
    if(filteredData && filteredData.length > 0) {
      let c = blockCalculations(filteredData!, "availability.worked", "availability.total", "shifts", tab)
      setCalculations(c)
      setLoading(false)
    }
  }, [filteredData])

  const getOptions = () => (
    {
      animation: false,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: {
            show: true,
            formatter: function (params: { value: string; }) {
              return params.value.replace('\n', '');
            }
          }
        }
      },
      legend: {
        icon: "circle",
        bottom: 0,
        formatter: function (name: string) {
          return t(name);
        }
      },
      grid: {
        left: "12px",
        right: "8px",
        bottom: "30px",
        top: "8px",
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: excludeFilters?.filteredDays,
        axisLabel: {
          formatter: function (value: string) {
            return DateTime.fromSQL(value).toFormat("dd");
          },
        }
      },
      yAxis: {
        type: 'value',
        offset: 0,
        position: "right",
        axisLabel: {
          formatter: function (value: string) {
            return `${value} %`;
          },
        },
        splitLine: {
          show: false
        }
      },
      series: calculations
    }
  );

  return (
    <div className="flex flex-col w-full">
      <div className="flex w-full py-2 h-72">
        {!loading && <ReactEcharts
          option={getOptions()}
          showLoading={loading}
          loadingOption={{
            text: '',
            color: hslColor.primary,
            // textColor: store.theme === "dark" ? hslColor.lightBorder : hslColor.darkBorder,
            // maskColor: store.theme === "dark" ? hexColor.borderForeground : hexColor.border,
            zlevel: 0,
            // Font size. Available since `v4.8.0`.
            fontSize: 12,
            // Show an animated "spinner" or not. Available since `v4.8.0`.
            showSpinner: true,
            // Radius of the "spinner". Available since `v4.8.0`.
            spinnerRadius: 8,
            // Line width of the "spinner". Available since `v4.8.0`.
            lineWidth: 2,
            // Font thick weight. Available since `v5.0.1`.
            fontWeight: 'normal',
            // Font style. Available since `v5.0.1`.
            fontStyle: 'normal',
            // Font family. Available since `v5.0.1`.
            fontFamily: 'sans-serif'
          }}
          ref={(e) => {
            setRef(e);
          }}
          style={{ width: "100%", height: "100%", minHeight: 100 }}
          opts={{ renderer: "canvas" }}
        />}
      </div>
    </div>
  )
}

function blockCalculations(filteredData: DataRow[], parameter: WidgetParameter, baseParameter: WidgetParameter, splitBy: SplitBy, tab: Tab):any[] {
  let keys = parameter.split(".")
  let baseKeys = baseParameter.split(".")
  let days: string[] = []
  let grouppedData = Object.entries(_.groupBy(filteredData, "dateShift.start_day")).map(i => {
    days.push(i[0])
    return i
  })

  let data = []

  if(splitBy === "persons") {
    tab.defaultValues!.persons!.map((p) => {

      let daysData: any = []
      
      days.map((day: string) => {

        let dayData = grouppedData.filter(([gd, gdata]) => gd === day).map(([gd, gdata]) => gdata.filter(r => r.person?.id === p.value)).flat()
        console.log(dayData)
        if(dayData && dayData.length > 0) {
          daysData.push((_.sum(dayData.map((i: any) => (i[keys[0]][keys[1]].seconds / i[baseKeys[0]][baseKeys[1]].seconds) * 100)) / dayData.length).toFixed(2));
        } else {
          daysData.push(0)
        }
      })

      data.push({
        name: `${p.label}`,
        type: 'line',
        data: daysData,
        smooth: true,
        emphasis: {
          focus: 'series'
        },
      })
    })
  }

  if(splitBy === "shifts") {
    tab.defaultValues?.shifts!.map((shift) => {
      let d = filteredData.filter(i => i.dateShift.id === shift.id)

      let daysData = []
      for (let i = 0; i < grouppedData.length; i++) {
        // @ts-ignore
        daysData.push((_.sum(grouppedData[i].filter(i => i.dateShift.id === shift.id).map(i => (i[keys[0]][keys[1]].seconds / i[baseKeys[0]][baseKeys[1]].seconds) * 100)) / grouppedData[i].filter(i => i.dateShift.id === shift.id).length).toFixed(2));
      }

      data.push({
        name: `${d[0].dateShift.label}`,
        type: 'line',
        data: daysData,
        smooth: true,
        emphasis: {
          focus: 'series'
        },
      })
    })
  }

  if(splitBy === "none") {
    let daysData = []
    for (let i = 0; i < grouppedData.length; i++) {
      // @ts-ignore
      daysData.push((_.sum(grouppedData[i].map(i => (i[keys[0]][keys[1]].seconds / i[baseKeys[0]][baseKeys[1]].seconds) * 100)) / grouppedData[i].length).toFixed(2));
    }
    data.push({
      name: t(parameter),
      type: 'line',
      data: daysData,
      smooth: true,
      emphasis: {
        focus: 'series'
      },
    })
  }

  return data
}